export default "__VITE_ASSET__f4a863fb__"